import {
  POST_NEW_CONTRACTOR_SUCCESS,
  POST_NEW_CONTRACTOR_FAILURE,
} from "../constants/MyM";

const initStat = { data: [], error: false, errorData: "", isLoading: true };

export default (state = initStat, action) => {
  switch (action.type) {
    case POST_NEW_CONTRACTOR_SUCCESS:
      return {
        ...state,
        data: action.payload,
        isLoading: false,
      };
    case POST_NEW_CONTRACTOR_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorData: action.payload,
        error: true,
      };
    default:
      return { ...state };
  }
};
